import { render } from "./TaskAdd.vue?vue&type=template&id=a17453fc"
import script from "./TaskAdd.vue?vue&type=script&lang=js"
export * from "./TaskAdd.vue?vue&type=script&lang=js"

import "./TaskAdd.vue?vue&type=style&index=0&id=a17453fc&lang=less"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__